<template>
    <div ref="back" class="back z-1 position-relative">
		<div class="vh-100 sticky-top d-flex flex-column">
			<div class="row g-0 z-1">
				<div class="col-12">
					<div class="px-0 d-flex align-items-center justify-content-center justify-content-md-start">
						<h1 class="display-1 fs-2 fw-bold py-3 px-2 bg-white rounded-2 text-dark ms-0 ms-lg-5">Experience & Education</h1>
					</div>
				</div>
			</div>
            <div class="d-none d-lg-grid vh-100 py-5 position-relative overflow-hidden">
                <div class="px-0 position-absolute top-0 start-0 h-100 z-1" style="box-shadow: 0 0 40px 30px rgba(0,0,0,1);"></div>
                <div class="px-5 z-0 d-grid overflow-scroll" style="grid-template-columns: repeat(6, 19%);grid-template-rows: 100%;">
                    <XpCard year="2020" :edu="true" :top="true" headline="Matriculated from Darul Arqam Islamic High School (DAIHS)."/>
                    <XpCard year="2020 - 2022" :edu="true" :top="false" headline="My self-teaching journey in Ethical Hacking, Scripting(Python, PHP, many more) begins."/>
                    <XpCard year="2022 - 2023" :edu="false" :top="true" headline="I casualled at click retail store."/>
                    <XpCard year="2023 - 2024" :edu="true" :top="false" headline="Life Choices Academy (LCA). Completed a 6 month coding course."/>
                    <XpCard year="2024 - 2024" :edu="false" :top="true" headline="Life Choices Studios (LCS). Currently a Intern."/>
                    <XpCard year="2024 - Now" :edu="false" :top="false" headline="Started working at FutureRent as Junior Developer, now currently a Intermediate Developer"/>
                </div>
                <div class="px-0 position-absolute bg-black top-0 end-0 h-100 z-1" style="box-shadow: 0 0 40px 30px rgba(0,0,0,1);"></div>
            </div>
            <div class="row g-0 vh-100 mx-0 py-0 py-lg-5 px-4 px-lg-5 flex-fill z-1 d-flex d-lg-none">
                <XpCard :class="{ 'd-none' : xpCardState[0] }" year="2020" :edu="true" :top="true" headline="Matriculated from Darul Arqam Islamic High School (DAIHS)."/>
                <XpCard :class="{ 'd-none' : xpCardState[1] }" year="2020 - 2022" :edu="true" :top="false" headline="My self-teaching journey in Ethical Hacking, Scripting(Python, PHP, many more) begins."/>
                <XpCard :class="{ 'd-none' : xpCardState[2] }" year="2022 - 2023" :edu="false" :top="true" headline="I casualled at click retail store."/>
                <XpCard :class="{ 'd-none' : xpCardState[3] }" year="2023 - 2024" :edu="true" :top="false" headline="Life Choices Academy (LCA). Completed a 6 month coding course."/>
                <XpCard :class="{ 'd-none' : xpCardState[4] }" year="2024 - 2024" :edu="false" :top="true" headline="Life Choices Studios (LCS). Currently a Intern."/>
                <XpCard :class="{ 'd-none' : xpCardState[5] }" year="Now" :edu="false" :top="false" headline="Future Rent Junior"/>
            </div>
            <div class="d-none">
                2020:
-> Matriculated From Darul Arqam.
- was prefect.
- 100m, long jump, athlete.
- Only found math interesting, it taught me how to build problem soliving mindset.

2020 - 2022:
-> My self-taught journey began.
-  I began to continue my self-taught knowledge on coding.
-  I ran into game dev with unity3d with C# but my pcs load times were too slow, I have no gpu.
-  I also challenged myself in python on codewars.
-  I was classified as a script kiddie according its description.
-  I trained and gain experience about red-hat and blue-hat hacking on platforms such as HackTheBox, TryHackMe, and many many more.
-  I tried to find the magic behind computers, I found out about logical operators and how they munipulate binary or bits.
-  I almost pursued building my own operating system.
-  I dont find learning a new language any challenging although I like to stick to python because I like to solve problems quickly.
-  I aspire to bridge my knowledge over to hardware programming(or robotics).
-  I felt like I was well sustained with knowledge. I still do.
-  I still didnt feel fulfulled because I had nothing to really do with my developed skills.
-  Even If I did build something would it even become widely used or even popular I thought.
-  I decided to Apply at LCA. I made it past the first test. tried to keep all my experience hidden. and acted dumb. eventually failed the test. and didnt get accepted.
 
2022 - 2023:
-> I casualled at click retail store in mitchells plain town centre for 3 months.
-  I was intending to become permanent because I thought if I could make money then I could get the computer I always wanted.
-  But with this dream my health both mentally and physically could not hold on for much longer. 
-  Aching feet with blisters everyday and dealing with moody customers absorbing all there energy and coming with it home, was super unhealthy for me.
-  I barely had time for myself and to even get a chance to work on a development project.
-  The only best part about working there was My Boss. She was the best and she could even hold a team together even in the darkest times.
-  My contract expired/terminated the end of January tho.

2023:
-> After I left Clicks I realised I needed more to learn and it was how to expose myself.
-  I began doing what I do not nessarily like doing because it changes me into someone I wish not to be(greedy).
-  I began to apply for competitions courses and even jobs with no proof of experience.
-  I went wild I even trust myself that I was capable of doing anything.
-  I joined a competition. They gave a entry level challenge to fix images in a specific order.
-  Suddenly my mind can't comprehend things that are seemingly useless. 
-  I read the senario probably about 4 times just to realise how simple it was.
-  I made it into the competition well enough with for loops slowing my python program runtime down.
-  I was shocked to see other people made it in with quicker solution runtime speeds.
-  Thats when I immediatly found out about C bindings with python was possible.
-  And also realize numpy was one of them hence why they scored faster solution times.
<!-- -  <show video to the competition> -->
-  Anyways we came 7th place, in the top 10 atleast "The readable regexes", I'm MrBud.
-  At the end of 2023 I decided to re-apply at LCA, I asked my friend to look out for hacking competitions.
-  I also applied for a UWC course just incase I failed again.
-  I was just going wild this time.

2023 - 2024:
-> I got a call from LCA to say that I've made it to the interview process.
-  I went for the interview, I thought I wasn't going to get in because someone gave me a bad impression.
-  My Interviewer(Whitney) came in and told me come there is this person waiting for you.
-  And I felt like I failed already.
-  In the interview I didnt beat around the bush, I told her I was nervous and I told her everything I knew, sockets, buffers, networking, etc.
-  I made sure I carried the message over that I was deeply passionate about this field.
-  Eventually I got accepted.
-  And in my 3rd day After signing a contract with LCA, I got another call from UWC.
-  Them wanting to have an interview with me, unfortunatly I was unavailable. 
-  I Questioned myself If I was loyal or scared of this part of me, to show it to the world. 
-  If it was loyalty it would make me a good asset.
-  If it was fear then I should realise how brave I'am.
-  There is no wrong answer and I dont care about status hence I made my choice final here at LCA.

2024:
-> I graduated from LCA 6 month course which including more than coding such as public speaking, personal development, life skills.
-  Achieved 3 awards, (Above 80% Achievement), (100% Attendance), Special Award(Coding Wizard).
-  This ended in march.

now:
-> I'm Currently an Intern at LCA.
            </div>
			<!-- <div class="hex position-absolute p-5 z-0" style="background-image: url(https://i.ibb.co/ygKVMXt/hex.png);">
				<div class="p-5">
					<div class="px-5">
						<div class="px-5">
							<div class="p-5">
								<div class="p-5">
									<div class="p-4"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>
        <div class="position-absolute w-100 h-100 top-0 start-0" :class="{ 'd-none' : show_xp_observers }">
            <div v-for="(i) in [0,1,2,3,4]" :key="i">
                <div :index="i" ref="experienceObserver" class="vh-100 w-100 apply-snap-scroll border border-4 border-dark"></div>
            </div>
        </div>
    </div>
</template>
<script>
import XpCard from '@/components/XpCard.vue';

export default {
	name: "ExperienceView",
    data(){
        return {
            xpCardState: [false, true, true, true, true, true],
            xpIndex: 0,
            show_xp_observers: false
        }
    },
	components: {
		XpCard
	},
    mounted(){
        this.$nextTick(() => {
            let experienceObserver = this.$refs.experienceObserver;
            // console.log(experienceObserver)

            experienceObserver.forEach( (elem) => {
                this.observer = new IntersectionObserver( this.handleObserver, {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.5
                } );

                this.observer.observe( elem );
            });
            this.handleResize();
            window.addEventListener('resize', this.handleResize)
        })

    },
    methods: {
        handleObserver(event){
            event.forEach( entry => {
                let experienceObserver = this.$refs.experienceObserver;

                if( entry.isIntersecting ){
                    let index = +entry.target.getAttribute('index');
                    this.xpIndex = index;
                }
                experienceObserver.forEach( (elem, index) => {
                    if( index == this.xpIndex ){
                        this.xpCardState[index] = false;
                    } else {
                        this.xpCardState[index] = true;
                    }
                } )
            })
        },
        handleResize(){
            let back = this.$refs.back;

            if( window.innerWidth <= 768 ){
                back.style['height'] = `${500}vh`;
                this.show_xp_observers = false;
            } else {
                back.style['height'] = `${100}vh`;
                this.show_xp_observers = true;
            }
        }
    }

}
</script>
<style scoped>
.back {
	height: 100vh;
}
.grad {
	background: linear-gradient(20deg, rgba(255, 255, 255, 0.8) 50%, rgba(0,0,0,1) 50.1%, rgba(0,0,0,1));
}
.hex {
	bottom: -10%;
	left: -1%;
	/* transform: rotate(90deg); */
	/* background-color: black; */
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
}
.snap-scroll {
    overflow-y: scroll;
    scroll-snap-type: y mandatory;
    scroll-behavior: smooth;
    /* scroll-padding: 40px; */
}
.apply-snap-scroll {
    scroll-snap-align: start;
}
</style>
